import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import MaterialIcon from "material-icons-react";
import i18n from "../../../i18next";
import {connect} from "react-redux";
import {removeUpsellProduct} from "../../../actions";

class DeleteUpsellProductModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: this.props.modalData.show,
            disableSubmit: false
        }
    }

    toggle = (refresh) => {
        this.setState({
            ...this.state,
            show: !this.state.show
        }, () => {
            setTimeout(() => {
                this.props.toggleModal(refresh);
            }, 500);
        });
    };

    removeProduct = () => {
        this.setState({...this.state, disableSubmit: true});
        this.props.removeUpsellProduct(this.props.restaurantId, this.props.modalData.upsellId, () => {
            this.toggle(true);
        });
    };

    render() {
        return (
            <Modal isOpen={this.state.show} toggle={this.toggle}>
                <ModalHeader toggle={this.toggle} className="modalHeader">{i18n.t('screens:upsellScreen.deleteModalHeader')}</ModalHeader>
                <ModalBody>
                    {i18n.t('screens:upsellScreen.deleteModalBody')}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        disabled={this.state.disableSubmit}
                        onClick={this.removeProduct}>
                        <MaterialIcon icon="check" color="#fff"
                                      size={20}/>&nbsp;{i18n.t('common:buttons.confirm')}</Button>{' '}
                    <Button color="outline-primary" onClick={this.toggle}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default connect(null, {removeUpsellProduct})(DeleteUpsellProductModal);


// WEBPACK FOOTER //
// ./src/components/restaurants/upsell/DeleteUpsellProductModal.js